import React, { useEffect, useState } from "react";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import "../../.csscode/PopUpModal.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import { Row, Col } from "reactstrap";

const User = ({ selectedId, mode, onHide, setRefresh }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState("");
  const [userid, setUserid] = useState("");
  const [password, setPassword] = useState("");
  const [empcode, setEmpcode] = useState("");
  const [active, setActive] = useState("");
  const [type, setType] = useState("");
  const [seccode, setSeccode] = useState("");
  const [divcode, setDivcode] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [typeActiveOption, setTypeActiveOption] = useState([{}]);
  const [typeOption, setTypeOption] = useState([{}]);
  const [empcodeList, setEmpcodeList] = useState([{}]);
  const [seccodeList, setSeccodeList] = useState([{}]);
  const [divcodeList, setDivcodeList] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //const dbName = useContext(dBNameContext);
  /*Initializer - Post Render */
  useEffect(() => {
    if (selectedId !== "") {
      axios
        .get(apiUrl + `user/${selectedId}`, { headers })
        .then((response) => {
          if (response.data.cd === 1) {
            toast.info(response.data.description);
          } else {
            setId(response.data.id);
            setUserid(response.data.userid);
            setPassword(response.data.password);
            setEmpcode(response.data.empcode);
            setActive(response.data.active);
            setType(response.data.type);
            setSeccode(response.data.seccode);
            setDivcode(response.data.divcode);
          }
        })
        .catch((error) => {
          alert("Some issue. Please check with Administrator..!", error);
        });
    }
    fetchempCode();
    fetchdivCode();
    fetchsecCode();
  }, []);

  // dynamic dropdown fetching data
  const fetchempCode = async () => {
    try {
      axios
        .get(apiUrl + "employee", { headers })
        .then((response) => {
          setEmpcodeList(response.data);
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));
          setEmpcodeList(sectionOption);
        })

        .catch((error) => {
          setEmpcodeList([{}]);
        });
    } catch (error) {
      setEmpcodeList([{}]);
    }
  };

  const fetchsecCode = async () => {
    try {
      axios
        .get(apiUrl + "section", { headers })
        .then((response) => {
          setSeccodeList(response.data);
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));
          setSeccodeList(sectionOption);
        })

        .catch((error) => {
          setSeccodeList([{}]);
        });
    } catch (error) {
      setSeccodeList([{}]);
    }
  };

  const fetchdivCode = async () => {
    try {
      axios
        .get(apiUrl + "division", { headers })
        .then((response) => {
          setDivcodeList(response.data);
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));
          setDivcodeList(sectionOption);
        })

        .catch((error) => {
          setDivcodeList([{}]);
        });
    } catch (error) {
      setDivcodeList([{}]);
    }
  };

  function clearFields() {
    setPassword("");
    setEmpcode("");
    setActive("");
    setType("");
    setSeccode("");
    setDivcode("");
  }

  const handlesubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    if (userid === "") {
      toast.error("Please Enter User Id..!");
      setLoading(false);
      return;
    }
    if (password === "") {
      toast.error("Please Enter Password..!");
      setLoading(false);
      return;
    }
    if (empcode === "") {
      toast.error("Please Enter Employee..!");
      setLoading(false);
      return;
    }
    if (divcode === "") {
      toast.error("Please Enter Department..!");
      setLoading(false);
      return;
    }

    if (mode === "A") {
      axios
        .post(
          apiUrl + "user",
          {
            userid: userid,
            password: password,
            empcode: empcode,
            active: active,
            type: type,
            seccode: seccode,
            divcode: divcode,
          },
          { headers },
        )
        .then((response) => {
          if (response.data.cd === 1) {
            setLoading(true);
            setSucessMessage(response.data.description);
            setTitle("⚠️ Failed");
            setShowSucessModal(true);
          } else {
            setLoading(true);
            setSucessMessage(response.data.description);
            setTitle("✔️ Success");
            setShowSucessModal(true);
          }
        });
    } else {
      axios
        .put(
          apiUrl + "user",
          {
            id: id,
            userid: userid,
            password: password,
            empcode: empcode,
            active: active,
            type: type,
            seccode: seccode,
            divcode: divcode,
          },
          { headers },
        )
        .then((response) => {
          if (response.data.cd === 1) {
            setLoading(true);
            setSucessMessage(response.data.description);
            setTitle("⚠️ Failed");
            setShowSucessModal(true);
          } else {
            setLoading(true);
            setSucessMessage(response.data.description);
            setTitle("✔️ Success");
            setShowSucessModal(true);
          }
        });
    }
  };

  //for static Set
  const handleType = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setType(selectedTypeValue);
    } else {
      setType("");
    }
  };

  //static Fetching
  const handleStatus = (selectedStatus) => {
    if (selectedStatus) {
      const selectedTypeStatus = selectedStatus.value;
      setActive(selectedTypeStatus);
    } else {
      setActive("");
    }
  };

  //for dynamic set
  const handleEmpCode = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setEmpcode(selectedTypeValue);
    } else {
      setEmpcode("");
    }
  };

  const handleSecCode = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setSeccode(selectedTypeValue);
    } else {
      setSeccode("");
    }
  };

  const handleDivCode = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setDivcode(selectedTypeValue);
    } else {
      setDivcode("");
    }
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999", // You can set a custom color if needed
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)", // Ensures it matches the bootstrap input height
    }),
  };

  if (mode === "A") {
    /*Handle Save */
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="popupmodal-maindiv">
          <Row>
            <Col md={6}>
              <label>User Id</label>
              <Tooltip title="User Id">
                <input
                  type="text"
                  placeholder="Enter User Id"
                  required
                  value={userid}
                  onChange={(e) => setUserid(e.target.value)}
                  className={"form-control mb-2"}
                ></input>
              </Tooltip>
            </Col>
            <Col md={6}>
              <label>Password</label>
              <Tooltip title="Password">
                <div style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={"form-control mb-2"}
                    style={{ paddingRight: "2.5rem" }}
                  ></input>
                  <div
                    onClick={togglePasswordVisibility}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  >
                    {showPassword ? (
                      <FaEyeSlash size={20} />
                    ) : (
                      <FaEye size={20} />
                    )}
                  </div>
                </div>
              </Tooltip>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label for="affiliationWard" className="font-weight-bold">
                  Employee Code
                </Label>
                <Select
                  name=" Employee Code"
                  value={empcodeList.find((option) => option.value === empcode)}
                  onChange={handleEmpCode}
                  placeholder="Select Employee"
                  options={empcodeList}
                  styles={customStyles}
                  classNamePrefix="select"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label for="affiliationType" className="font-weight-bold">
                  Active Status
                </Label>
                <Select
                  name="Active Status"
                  value={typeActiveOption.find(
                    (option) => option.value === active,
                  )}
                  onChange={handleStatus}
                  placeholder="Select Active Status"
                  options={typeActiveOption}
                  styles={customStyles}
                  classNamePrefix="select"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label for="affiliationType" className="font-weight-bold">
                  User Type
                </Label>
                <Select
                  name="User Type"
                  value={typeOption.find((option) => option.value === type)}
                  onChange={handleType}
                  placeholder="Select Type"
                  options={typeOption}
                  styles={customStyles}
                  classNamePrefix="select"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label for="affiliationType" className="font-weight-bold">
                  Section
                </Label>
                <Select
                  name="Section"
                  value={seccodeList.find((option) => option.value === seccode)}
                  onChange={handleSecCode}
                  placeholder="Select Section"
                  options={seccodeList}
                  styles={customStyles}
                  classNamePrefix="select"
                />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup className="mb-3">
            <Label for="affiliationType" className="font-weight-bold">
              Department
            </Label>
            <Select
              name="User Department"
              value={divcodeList.find((option) => option.value === divcode)}
              onChange={handleDivCode}
              placeholder="Select Type"
              options={divcodeList}
              styles={customStyles}
              classNamePrefix="select"
            />
          </FormGroup>

          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
        </div>
      </>
    );
  } else if (mode === "U") {
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="popupmodal-maindiv">
          <Row>
            <Col md={6}>
              <label>User Id</label>
              <Tooltip title="User Id">
                <input
                  type="text"
                  placeholder="Enter User Id"
                  required
                  value={userid}
                  onChange={(e) => setUserid(e.target.value)}
                  className={"form-control mb-2"}
                ></input>
              </Tooltip>
            </Col>
            <Col md={6}>
              <label>Password</label>
              <Tooltip title="Password">
                <div style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={"form-control mb-2"}
                    style={{ paddingRight: "2.5rem" }}
                  ></input>
                  <div
                    onClick={togglePasswordVisibility}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  >
                    {showPassword ? (
                      <FaEyeSlash size={20} />
                    ) : (
                      <FaEye size={20} />
                    )}
                  </div>
                </div>
              </Tooltip>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label for="affiliationWard" className="font-weight-bold">
                  Employee Code
                </Label>
                <Select
                  name=" Employee Code"
                  value={empcodeList.find((option) => option.value === empcode)}
                  onChange={handleEmpCode}
                  placeholder="Select Employee"
                  options={empcodeList}
                  styles={customStyles}
                  classNamePrefix="select"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label for="affiliationType" className="font-weight-bold">
                  Active Status
                </Label>
                <Select
                  name="Active Status"
                  value={typeActiveOption.find(
                    (option) => option.value === active,
                  )}
                  onChange={handleStatus}
                  placeholder="Select Active Status"
                  options={typeActiveOption}
                  styles={customStyles}
                  classNamePrefix="select"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label for="affiliationType" className="font-weight-bold">
                  User Type
                </Label>
                <Select
                  name="User Type"
                  value={typeOption.find((option) => option.value === type)}
                  onChange={handleType}
                  placeholder="Select Type"
                  options={typeOption}
                  styles={customStyles}
                  classNamePrefix="select"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label for="affiliationType" className="font-weight-bold">
                  Section
                </Label>
                <Select
                  name="Section"
                  value={seccodeList.find((option) => option.value === seccode)}
                  onChange={handleSecCode}
                  placeholder="Select Section"
                  options={seccodeList}
                  styles={customStyles}
                  classNamePrefix="select"
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup className="mb-3">
            <Label for="affiliationType" className="font-weight-bold">
              Department
            </Label>
            <Select
              name="User Department"
              value={divcodeList.find((option) => option.value === divcode)}
              onChange={handleDivCode}
              placeholder="Select Type"
              options={divcodeList}
              styles={customStyles}
              classNamePrefix="select"
            />
          </FormGroup>

          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
        </div>
      </>
    );
  }
};

export default User;
